/**
 *
 * Asynchronously loads the component for SelectorForm
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SelectorForm = lazyLoad(
  () => import('./index'),
  module => module.SelectorForm,
);
